"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VerticalSpacer_1 = __importDefault(require("../../../../utils/VerticalSpacer"));
var TextVerticalSpacer_1 = __importDefault(require("../../../../utils/TextVerticalSpacer"));
var HorizontalSpacer_1 = __importDefault(require("../../../../utils/HorizontalSpacer"));
var Icon_1 = __importDefault(require("../../../../basics/Icon"));
var typography_1 = require("../../../../typography");
var Link_1 = __importDefault(require("../../../../navigation/Link"));
var Markdown_1 = __importDefault(require("../../../../utils/Markdown"));
var VS_1 = { small: 8, medium: 12, large: 16 };
var HS_1 = { small: 4, medium: 4, large: 4 };
var ICON_SIZE_1 = { small: 20, medium: 20, large: 20 };
var HS_2 = { small: 8, medium: 8, large: 8 };
var ICON_SIZE = { small: 20, medium: 20, large: 20 };
var MARKDOWN_1_OVERRIDES = {
    div: function (_a) {
        var children = _a.children;
        return react_1.default.createElement(TextVerticalSpacer_1.default, { level: "4" }, children);
    },
    p: function (_a) {
        var children = _a.children;
        return react_1.default.createElement(typography_1.Body, { level: "3" }, children);
    },
    a: function (_a) {
        var href = _a.href, children = _a.children;
        return (react_1.default.createElement(Link_1.default, { href: href, isExternal: true }, children));
    },
};
var PersonInfo = function (_a) {
    var description = _a.description, location = _a.location, instagram = _a.instagram, facebook = _a.facebook, twitter = _a.twitter, commonProps = __rest(_a, ["description", "location", "instagram", "facebook", "twitter"]);
    return (react_1.default.createElement(VerticalSpacer_1.default, __assign({ "data-component-name": "PersonInfo" }, commonProps, { amount: VS_1 }),
        react_1.default.createElement(TextVerticalSpacer_1.default, { level: "4" },
            location && (react_1.default.createElement(HorizontalSpacer_1.default, { amount: HS_1 },
                react_1.default.createElement(Icon_1.default, { name: "location", color: "GREY_50" }),
                react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_70" }, location))),
            react_1.default.createElement(Markdown_1.default, { overrides: MARKDOWN_1_OVERRIDES }, description)),
        react_1.default.createElement(HorizontalSpacer_1.default, { amount: HS_2 },
            instagram && (react_1.default.createElement(Link_1.default, { href: instagram, isExternal: true, ariaLabel: "View Instagram" },
                react_1.default.createElement(Icon_1.default, { name: "instagram", size: ICON_SIZE }))),
            facebook && (react_1.default.createElement(Link_1.default, { href: facebook, isExternal: true, ariaLabel: "View Facebook" },
                react_1.default.createElement(Icon_1.default, { name: "facebook", size: ICON_SIZE }))),
            twitter && (react_1.default.createElement(Link_1.default, { href: twitter, isExternal: true, ariaLabel: "View Twitter" },
                react_1.default.createElement(Icon_1.default, { name: "twitter", size: ICON_SIZE }))))));
};
exports.default = PersonInfo;
